import { useEffect, useState } from 'react';
import { DataCheck } from '../lib/date-check';
import Card from './layout/Card';

const SetArticles = ({ category, country }) => {
  const [attrData, setAttrData] = useState('');
  const [loadedArticles, setLoadedArticles] = useState([]);
  const [error, setError] = useState('');
  const [registerDB, setRegisterDB] = useState(false);
  const [articlesId, setArticlesId] = useState('');

  // attrData更新用：一度だけ更新するように useEffect 分離
  useEffect(() => {
    const newAttr = `${category}_${country}`;
    if (attrData !== newAttr) {
      setAttrData(newAttr);
      setLoadedArticles([]); // リセット
    }
  }, [category, country]);

  // Databaseから取得
  useEffect(() => {
    if (loadedArticles.length === 0 && attrData !== '') {
      fetch(`https://news-tag-node.vercel.app/api/articles?attr=${attrData}`)
        .then((res) => {
          if (!res.ok) {
            throw new Error('Failed to fetch article');
          }
          return res.json();
        })
        .then((data) => {
          if (!data) {
            // Firebaseに存在しない場合（null）
            setError('overwriting');
            return;
          }

          const keys = Object.keys(data);
          if (keys.length === 0) {
            setError('No articles found');
            return;
          }

          const firstKey = keys[0];
          const articleObj = data[firstKey];

          if (!DataCheck(articleObj.date)) {
            setArticlesId(firstKey);
            setError('overwriting');
          } else {
            setLoadedArticles(articleObj.articles);
          }
        })
        .catch((error) => setError('Database Error: ' + error.message));
    }
  }, [attrData, loadedArticles.length]);

  // NewsAPIから取得
  useEffect(() => {
    if (error === 'overwriting') {
      fetch(`https://news-tag-node.vercel.app/api/news?country=${country}&category=${category}`)
        .then((res) => {
          if (!res.ok) {
            return res.json().then((data) => {
              throw new Error(data.message || 'Unknown error');
            });
          }
          return res.json();
        })
        .then((data) => {
          if (!data.articles || data.articles.length === 0) {
            setError('No articles found');
            return;
          }

          setLoadedArticles(data.articles);
          setRegisterDB(true);
        })
        .catch((error) => {
          setError('NewsAPI Error: ' + error.message);
        });
    }
  }, [error, category, country]);

  // DB登録
  useEffect(() => {
    if (!registerDB) return;

    const payload = JSON.stringify({
      date: new Date().toLocaleString('en-US'),
      articles: loadedArticles,
    });

    const method = articlesId ? 'PUT' : 'POST';
    const idParam = articlesId ? `&id=${articlesId}` : '';

    fetch(`https://news-tag-node.vercel.app/api/articles?attr=${attrData}${idParam}`, {
      method,
      headers: {
        'Content-Type': 'application/json',
      },
      body: payload,
    })
      .then((res) => {
        if (!res.ok) {
          return res.json().then((data) => {
            throw new Error(data.message || 'Unknown error');
          });
        }
        // 登録成功時は状態リセット
        setRegisterDB(false);
        setArticlesId('');
        setError('');
      })
      .catch((error) => setError('Register DB Error: ' + error.message));
  }, [registerDB]);

  return (
    <section>
      {error === 'No articles found' ? (
        <p style={{ paddingTop: '1rem', paddingLeft: '1rem' }}>No articles found for this category and country.</p>
      ) : (
        <Card articles={loadedArticles} />
      )}
    </section>
  );
};

export default SetArticles;